import axios from 'axios'

import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const ADD_DISCOUNT = 'ADD_DISCOUNT'
export const REQUEST_DISCOUNTS = 'REQUEST_DISCOUNTS'
export const RECEIVE_DISCOUNTS = 'RECEIVE_DISCOUNTS'

export const requestDiscount = () => (dispatch) => {
    dispatch({ type: REQUEST_DISCOUNTS })

    return axios
        .get('/userdiscounts')
        .then((response) => {
            const data = response?.data || []

            dispatch(receiveDiscount({ data, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

export const receiveDiscount = (data) => ({ type: RECEIVE_DISCOUNTS, data })

export const addDiscount =
    ({ discountCode, quarterlyTaxReturnsAnnualSummaryId, taxReturnId, isSubscription }) =>
    (dispatch) => {
        dispatch({ type: ADD_DISCOUNT, data: { discountCode, quarterlyTaxReturnsAnnualSummaryId, taxReturnId } })

        return axios
            .post(`/userdiscounts${isSubscription ? '/subscription' : ''}`, {
                discountCode,
                taxReturnId,
                quarterlyTaxReturnsAnnualSummaryId,
            })
            .then(() => {
                dispatch(receiveSuccessAlert(`Código de descuento '${discountCode}' aplicado correctamente`))
                dispatch(requestDiscount())
            })
            .catch((error) => {
                dispatch(
                    handleRequestError(error, {
                        customMessage: `El código de descuento '${discountCode}' no es válido`,
                        hideAlert: true,
                    })
                )
                return Promise.reject(error)
            })
    }
